// removed by extract-text-webpack-plugin
module.exports = {"container":"src-pages-__Home-module___container","submitButton":"src-pages-__Home-module___submitButton","transcription":"src-pages-__Home-module___transcription","select":"src-pages-__Home-module___select","voiceCommand":"src-pages-__Home-module___voiceCommand","voiceCommandText":"src-pages-__Home-module___voiceCommandText"};


//////////////////
// WEBPACK FOOTER
// ./src/pages/Home.module.css
// module id = 665
// module chunks = 0